import type { ComponentProps } from "react"
import { AccordionTrigger as AccordionTriggerBase } from "@/v2-ui/accordion/base/AccordionBase"
import cn from "@/v2-ui/utils/utils.cn"

export type AccordionTriggerProps = ComponentProps<typeof AccordionTriggerBase>

function AccordionTrigger(props: AccordionTriggerProps) {
  const { className, ...accordionTriggerBaseProps } = props
  return (
    <AccordionTriggerBase
      className={cn("ui-accordion-trigger", className)}
      {...accordionTriggerBaseProps}
    />
  )
}

export default AccordionTrigger
